





















































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class InvocationPeriodSelection extends Vue {
  @Prop({type: Array, required: true}) periodOptions!: string[]
  @Prop({type: String, required: true}) selectedPeriod!: string

  handleSelectPeriod(option: string) {
    this.$emit('select-period', option)
  }
}
